<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick" transfer-class-name="custom-draw-top">
      <Avatar size="large" :title="userAccount">{{userName}}</Avatar>
      <Icon style="font-size: 0.375rem;vertical-align: middle;" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!--暂时不放出修改密码-->
        <!--<DropdownItem name="update">{{$t('update_password')}}</DropdownItem>-->
        <!-- <DropdownItem name="message" v-show="hasUploadInfoRole">
          {{$t('more_menu_reporting_information')}}
          <Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem> -->
        <DropdownItem name="full"><svg-icon :iconClass="full_svg" className="classT"></svg-icon>{{$t('full_screen')}}</DropdownItem>
        <DropdownItem name="setting"><svg-icon :iconClass="setting_svg" className="classT"></svg-icon>{{$t('setting')}}</DropdownItem>
        <DropdownItem name="logout"><svg-icon :iconClass="logout_svg" className="classT"></svg-icon>{{$t('logout')}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Modal :title="$t('update_password')" v-model="showChange" width="30%" scrollable transfer @on-visible-change="visibleChange">
      <Form :model="passwordForm" :label-width="100" ref="form" :rules="rules">
        <FormItem :label="$t('old_pass')" prop="oldPassword">
          <Input v-model="passwordForm.oldPassword" :placeholder="$t('old_pass_placeHolder')" type="password"></Input>
        </FormItem>
        <FormItem :label="$t('new_pass')" prop="newPassword">
          <Input v-model="passwordForm.newPassword" :placeholder="$t('new_pass_placeHolder')" type="password"></Input>
        </FormItem>
        <FormItem :label="$t('again_pass')" prop="againPassword">
          <Input v-model="passwordForm.againPassword" :placeholder="$t('again_pass_placeHolder')" type="password"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit">{{$t('sure')}}</Button>
        <Button type="primary" @click="cancel">{{$t('cancel')}}</Button>
      </div>
    </Modal>
    <!--退出登录-->
    <Modal v-model="showLogout" :title="$t('logout')"width="20%">
      <p class="wordClass">{{$t('sure_logout')}}</p>
      <div slot="footer">
        <Button type="primary" @click="sureLogout">{{$t('sure')}}</Button>
        <Button type="default" @click="showLogout = false">{{$t('cancel')}}</Button>
      </div>
    </Modal>
    <Setting :show="showSetting" @closeSetting="closeSetting" :showAuto="showAuto" :supportVideo="supportVideo" :userId="userId"></Setting>
  </div>
</template>

<script>
  import './user.less'
  import { mapActions } from 'vuex'
  import {updatePassword} from "@/api/user"
  import Setting from '../setting/setting'
  import {baseImg} from '@/libs/base'


  export default {
    name: 'User',
    mixins:[baseImg],
    components: {Setting},
    props: {
      userAvatar: {
        type: String,
        default: ''
      },
      userAccount: {
        type: String,
        default: ''
      },
      userId: {
        type:String|Number
      },
      messageUnreadCount: {
        type: Number,
        default: 0
      },
      hasUploadInfoRole: {
        type: Boolean,
        default: false
      },
      showAuto:{
        type: Boolean,
        default: false
      },
      supportVideo:{
        type: Boolean,
        default: false
      }
    },
    data() {
      const pwdCheck = (rule, value, callback) => {
        let str = value
        let reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/)
        if (str == null || str.length < 6) {
          callback(new Error(this.$t('password_error')))
        } else if (!reg.test(str)) {
          callback(new Error(this.$t('password_error')))
        } else {
          callback()
        }
      }
      const pwdCheckValidate = (rule, value, callback) => {
        let str = value
        if (str == null || str.length < 6) {
          callback(new Error(this.$t('password_error')))
          this.compare = true
        } else if (this.passwordForm.newPassword !== this.passwordForm.againPassword) {
          callback(new Error(this.$t('password_error2')))
          this.compare = true
        } else {
          this.compare = false
          callback()
        }
      }
      return {
        showChange: false,
        passwordForm: {
          oldPassword: '',
          newPassword: '',
          againPassword: ''
        },
        rules: {
          oldPassword: [
            {required: true, validator: pwdCheck, trigger: 'blur'}
          ],
          newPassword: [
            {required: true, validator: pwdCheck, trigger: 'blur'}
          ],
          againPassword: [
            {required: true, validator: pwdCheckValidate, trigger: 'blur'}
          ],
        },
        count: 1,
        isFull: false,
        showSetting: false,
        showLogout:false,
      }
    },
    methods: {
      ...mapActions([
        'handleLogOut',
        'closeWS',
        'getUserInfo',
        'sendMsg'
      ]),
      visibleChange(val) {
        if (!val) {
          this.$refs.form.resetFields()
        }
      },
      logOut() {
        this.showLogout = true
      },
      sureLogout() {
        let that = this
        this.handleLogOut().then(() => {
          //发送登出事件
          let method = 'logout'
          that.sendMsg({method})
          that.closeWS()
          this.$root.bus.$emit('logout',true)
          window.sessionStorage.clear()
          //window.localStorage.clear()
          this.$emit('monitorOpenclose');
          //clearToken()
          that.$router.push({
            name: 'login'
          })
        })
      },
      submit() {
        let _this = this
        this.$refs.form.validate((vali) => {
          if (vali) {
            let userId = _this.$store.state.user.userId
            let userName = _this.$store.state.user.userName
            let oldPassword = _this.passwordForm.oldPassword
            let newPassword = _this.passwordForm.againPassword
            updatePassword(userId, userName, oldPassword, newPassword).then(res => {
              let response = res.data
              if (response.code === 200) {
                _this.$Message.success(_this.$t('success'))
                _this.getUserInfo()
              } else {
                if (response.msg) {
                  _this.$Message.error(_this.$t('password_error1'))
                } else {
                  _this.$Message.error(response.msg)
                }
              }
            })
            _this.$refs.form.resetFields()
            _this.showChange = false
          }
        })
      },
      cancel() {
        this.$refs.form.resetFields()
        this.showChange = false
      },
      updatepassword() {
        this.showChange = true
      },
      full() {
        let main = document.body
        if (this.isFull) {
          if (document.exitFullScreen) {
            document.exitFullScreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          }
        } else {
          if (main.requestFullscreen) {
            main.requestFullscreen()
          } else if (main.mozRequestFullScreen) {
            main.mozRequestFullScreen()
          } else if (main.webkitRequestFullScreen) {
            main.webkitRequestFullScreen()
          } else if (main.msRequestFullscreen) {
            main.msRequestFullscreen()
          }
        }
        this.isFull = !this.isFull
      },
      setting() {
        this.showSetting = true
      },
      closeSetting(value) {
        if (value) {
          this.showSetting = false
        }
      },
      message() {
        this.$router.push({
          name: 'reporting_information'
        })
      },
      handleClick(name) {
        switch (name) {
          case 'logout':
            this.logOut()
            break
          case 'full':
            this.full()
            break
          case 'setting':
            this.setting()
            break
        }
      }
    },
    mounted() {
      let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
      isFullscreen = !!isFullscreen
      document.addEventListener('fullscreenchange', () => {
        this.$emit('input', !this.value)
        this.$emit('on-change', !this.value)
      })
      document.addEventListener('mozfullscreenchange', () => {
        this.$emit('input', !this.value)
        this.$emit('on-change', !this.value)
      })
      document.addEventListener('webkitfullscreenchange', () => {
        this.$emit('input', !this.value)
        this.$emit('on-change', !this.value)
      })
      document.addEventListener('msfullscreenchange', () => {
        this.$emit('input', !this.value)
        this.$emit('on-change', !this.value)
      })
      this.$emit('input', isFullscreen)

      window.onresize = () => {//记录页面变化
        return (() => {
          this.$store.commit('setSysHeight', document.body.clientHeight)
          this.$store.commit('setSysWidth', document.body.clientWidth)
        })()
      }
    },
    computed:{
      userName(){
        let name = ''
        if (this.userAccount) {
          /*let reg = new RegExp("[\\u4E00-\\u9FFF]+","g")
          if (this.userAccount.length > 2) {
            let test = this.userAccount.substring(0, 2)
            if (reg.test(test)) {
              name = test + '...'
            } else {
              if (this.userAccount.length > 4) {
                let test = this.userAccount.substring(0, 4)
                if (reg.test(test)) {
                  name = this.userAccount.substring(0, 4) + '...'
                } else {
                  name = test + '...'
                }
              } else {
                name = this.userAccount
              }
            }
          } else {
            name = this.userAccount
          }*/
          if (this.userAccount.length > 2) {
            name = this.userAccount.substring(0, 2)
          } else {
            name = this.userAccount
          }
        }
        return name
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/main/components/user/user.vue